// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-preview[data-v-5ada84ae] {\n  max-width: 240px;\n}", ""]);
// Exports
module.exports = exports;
